module.exports = __webpack_public_path__ + "img/usdoicon@3x.97573b1a.png";